<template>
  <div class="admin-venue-distributors">
    <ez-table
      :data="distributors"
      :loading="isLoading"
      :columns="['name', 'status', 'actions']"
      :columnProps="{
        actions: { class: 'actions-cell' },
      }"
      disable-hover>
      <template #cell-name="{ row }">
        <v-distributor-entity-info :distributor="row" />
      </template>
      <template #cell-status="{ row }">
        <status-badge :status="row.status || 'draft'"></status-badge>
      </template>
      <template #cell-actions="{ row }">
        <ez-toggle
          :isActive="connectedVenueIds.includes(row.id)"
          @toggleState="toggleVenueConnect($event, row)">
          <template #active>
            <span>Connected</span>
          </template>
          <template #inactive>
            <span>Connect</span>
          </template>
        </ez-toggle>
      </template>
    </ez-table>
    <not-listed>
      <span>{{ $helpers.remapNaming('distributor')}} not on a list?</span>
      <template #action>
        <ez-button type="blue-link" @click="redirectToCreateDistributorWizard">
          Add new {{ $helpers.remapNaming('distributor', 'lower')}}
        </ez-button>
      </template>
    </not-listed>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import flash from '@/components/ui/FlashMessage';
import EzButton from '@/components/ui/Button';
import NotListed from '@/views/admin/common/not-listed';
import EzTable from '@/components/ui/Table';
import EzToggle from '@/components/ui/Toggle';
import StatusBadge from '@/views/common/status-badge';
import Venue from '@/models/Venue';
import Distributor from '@/models/Distributor';
import VDistributorEntityInfo from '@/components/v3/patterns/VDistributorEntityInfo';

export default {
  components: {
    EzButton,
    NotListed,
    EzTable,
    EzToggle,
    StatusBadge,
    VDistributorEntityInfo,
  },
  props: {
    venueId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      distributorFormKey: 'create-distributor-venue',
      distributors: [],
    };
  },
  computed: {
    venue() {
      return Venue.query()
        .with('connectedDistributors')
        .find(this.venueId);
    },
    connectedVenueIds() {
      return this.venue.connectedDistributors.map(d => d.id);
    },
    ...mapGetters('loading', ['getLoading']),
    isLoading() {
      return this.getLoading('get-venue-distributors');
    },
  },
  methods: {
    toggleVenueConnect(connect, row) {
      const { venueId } = this;

      if (connect) {
        return this.disconnectVenueFromDistributor({
          venueId,
          distributorId: row.id,
        });
      }

      return this.connectVenueWithDistributor({
        venueId,
        distributorId: row.id,
      });
    },
    redirectToCreateDistributorWizard() {
      this.$router.push('/suppliers/new');
    },
    onDistributorCreated({ data }) {
      Distributor.insert({ data: data.data });


      flash.success({
        title: `${this.$helpers.remapNaming('distributor')} successfully added!`,
      });
    },
    ...mapActions('entities/venues', [
      'fetchVenue',
      'connectVenueWithDistributor',
      'disconnectVenueFromDistributor',
      'adminFetchConnectedSuppliers',
    ]),
  },
  async created() {
    const { venueId } = this;

    const { data } = await this.adminFetchConnectedSuppliers({ venueId });
    this.distributors = data.data;
  },
};
</script>

<style scoped lang="scss">
  $table-border-radius: .6em;
  $not-listed-text-color: #252631;
  $not-listed-border-color: rgba(117, 128, 141, 0.2);

  .admin-venue-distributors {
    @include font-size(14px);
    display: flex;
    flex-direction: column;

    .distributor-form {
      margin: 1.5rem auto;
    }

    .table {
      tr:first-child {
        td:first-child {
          border-top-left-radius: $table-border-radius;
        }

        td:last-child {
          border-top-right-radius: $table-border-radius;
        }
      }

      .actions-cell {
        width: 10rem;
        text-align: right;
      }

      .ez-toggle {
        margin-left: auto;
        max-width: 7.25rem;
      }
    }
  }
</style>
